import React from "react";
export class MapControl extends React.Component<MapControlProps, any>{
    private _getElements = () => {
        if (this.props.children) {
            return this.props.children;
        }
        else {
            return <div style={this.props.textStyle}>
                {this.props.text}
            </div>;
        }
    }

    render() {
        return <div onClick={this.props.clickHandler} style={this.props.uiStyle} title={this.props.title}>
            {this._getElements()}
        </div>;
    }
}

export interface MapControlProps extends React.PropsWithChildren {
    uiStyle: React.CSSProperties;
    textStyle?: React.CSSProperties;
    clickHandler(e: React.MouseEvent<HTMLDivElement>): void;
    text?: string;
    title: string;
}
